import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitud from './NuevaSolicitudCuenta';

//Importación de actions.
import {
    cargarDatosPantalla,
    seleccionarCuenta,
    productoSelected,
    selectCombo,
    onBlurTextBox,
    radioMonedaSelected,
    seleccionarPromotor,
    validateCuenta,
    correspondenciaModo,
    selectCheckBox,
    hidePopUp,
    guardarBorrador,
    changeInput,
    loadDataFromTarjetas,
    setRedirectVistaCliente,
    reiniciarStateCuenta,
    routeToVistaCliente,
    routeToNuevaSolicitudTipoEmpresa,
    flagDatosModificacionCargados,
    volverASolicitudNSC,
    retrievingProductData,
    backAdicionales,
    selectSucursal,
    cargarDatosModificacion,
    cargarAdicionalesModificacion,
    cargarClienteTarjeta,
    confirmarClienteTarjeta,
    selectDomicilioVisa
} from '../actions/NuevaSolicitudCuentaActions';

//importa acción buscar clientes para adicionales
import {
    buscarPorCuit
} from '../../ClientSearch/actions/Actions';



const mapStateToProps = ( state ) => {
    return {
        data: state.nuevaSolicitudCuenta,
        tarjetas: state.tarjetas,
        tipoEmpresa: state.tarjetas.tipoEmpresa
    }
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
    return {
        cargarDatosPantalla: (currentScope) => {
            dispatch(cargarDatosPantalla(currentScope));
        },
        cargarDatosModificacion: (seccionCargada) => {
            dispatch(cargarDatosModificacion(seccionCargada));
        },
        cargarAdicionalesModificacion: () => {
            dispatch(cargarAdicionalesModificacion());
        },
        buscarPorCuit: (doc, obtenidoDePadron) => {
            dispatch(buscarPorCuit(doc, obtenidoDePadron));
        },
        confirmarClienteTarjeta: (value,cliente) => {
            dispatch(confirmarClienteTarjeta(value,cliente));
        },
        selectSucursal: (idSucursal) => {
            dispatch(selectSucursal(idSucursal));
        },
        selectDomicilioVisa: (domicilio,tipo) => {
            dispatch(selectDomicilioVisa(domicilio,tipo));
        },
        retrievingProductData: (payload) => {
            dispatch(retrievingProductData(payload));
        },
        backAdicionales: () => {
            dispatch(backAdicionales());
        },
        loadDataFromTarjetas: (prop) => {
            dispatch(loadDataFromTarjetas(prop));
        },
        flagDatosModificacionCargados: (seccion) => {
            dispatch(flagDatosModificacionCargados(seccion));
        },
        volverASolicitudNSC: () => {
            dispatch(volverASolicitudNSC());
        },
        selectCombo: (action,id) => {
            dispatch(selectCombo(action,id));
        },
        selectCheckBox: (action) => {
            dispatch(selectCheckBox(action));
        },
        seleccionarPromotor: (promotor) => {
            dispatch(seleccionarPromotor(promotor));
        },
        reiniciarStateCuenta: () => {
            dispatch(reiniciarStateCuenta());
        },
        productoSelected: (productoId) => {
            dispatch(productoSelected(productoId));
        },
        onBlurTextBox: (action, value) => {
            dispatch(onBlurTextBox(action, value));
        },
        radioMonedaSelected: (value) => {
            dispatch(radioMonedaSelected(value));
        },
        guardarBorrador: () => {
            dispatch(guardarBorrador());
        },
		correspondenciaModo: (value) => {
            dispatch(correspondenciaModo(value));
        },
        validateCuenta: (data) => {
            dispatch(validateCuenta(data));
        },
        changeInput: (action, value) => {
            dispatch(changeInput(action, value));
        },
        hidePopUp: (nombre, nuevoNombre) => {
            dispatch(hidePopUp(nombre, nuevoNombre));
        },
        setRedirectVistaCliente: () => {
            dispatch(setRedirectVistaCliente());
        },
        routeToVistaCliente: () => {
            dispatch(routeToVistaCliente());
        },
        routeToNuevaSolicitudTipoEmpresa: () => {
            dispatch(routeToNuevaSolicitudTipoEmpresa());
        }
    }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudCuentaContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitud);

export default NuevaSolicitudCuentaContainer;

